<template>
  <v-menu v-model="helpMenu" offset-y top nudge-top="15" open-on-hover>
    <v-btn slot="activator" :small="mobile" color="primary" fixed bottom right fab>
      <v-icon>help_outline</v-icon>
    </v-btn>
    <v-card style="max-width: 300px;">
      <v-card-text>
        <i18n path="help.intro">
          <a href="mailto:info@mistercalcio.com">info@mistercalcio.com</a>
        </i18n>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { isMobile } from '@/lib/common';

export default {
  computed: {
    mobile() {
      return isMobile();
    },

    helpMenu: {
      get() {
        return this.$store.state.helpMenu;
      },
      set(value) {
        this.$store.commit('helpMenu', value);
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Help.vue